import React from "react";
import { Table, Spinner } from "react-bootstrap";
import "../../../assets/styles/informationLayer.scss";

const InformationBulkUpdateItemsList = ({
  addresses = [],
  loading = false,
  selectedIds = [],
  missingIds = [],
}) => {
  const hasData = addresses.some((a) => !a.__missing);
    const foundCount = addresses.filter((a) => !a.__missing).length;

    if (loading) {
        return (
            <div className="information-bulk-update-card information-bulk-update-card--state">
                <div className="information-bulk-update-state">
                    <Spinner animation="border" size="sm" />
                    <span>Ładowanie podglądu rekordów...</span>
                </div>
            </div>
        );
    }

    if (!selectedIds.length) {
        return (
            <div className="information-bulk-update-card information-bulk-update-card--state">
                <div className="information-bulk-update-card__body">
                    <div className="information-bulk-update-empty-state">
                        <span className="information-bulk-update-empty-state__title">Brak wybranych ID</span>
                        <small>Dodaj parametry `ids`, aby zobaczyć konkretne rekordy objęte zmianą.</small>
                    </div>
                </div>
            </div>
        );
    }

  if (!hasData && missingIds.length === selectedIds.length) {
        return (
            <div className="information-bulk-update-card information-bulk-update-card--state">
                <div className="information-bulk-update-card__body">
                    <div className="information-bulk-update-empty-state information-bulk-update-empty-state--warning">
                        <span className="information-bulk-update-empty-state__title">Nie znaleziono żadnych rekordów</span>
                        <small>Żaden z przekazanych identyfikatorów nie zwrócił danych do aktualizacji.</small>
                    </div>
                </div>
            </div>
        );
  }

    return (
        <div className="information-bulk-update-card information-bulk-update-card--preview-list">
            <div className="information-bulk-update-card__header">
                <div>
                    <h5 className="mb-1">Rekordy objęte aktualizacją</h5>
                    <p className="mb-0 text-muted">
                        Odnaleziono {foundCount} z {selectedIds.length} wskazanych rekordów.
                    </p>
                </div>
            </div>
            <div className="information-bulk-update-card__body">
                <Table striped bordered hover responsive size="sm" className="layer-table mt-0">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Dane adresowe</th>
                </tr>
            </thead>
            <tbody>
                {addresses.map((addr) => (
                    <tr key={addr.id} className={addr.__missing ? "table-danger" : ""}>
                        <td>{addr.id}</td>
                        <td>
                            {addr.__missing ? (
                                <em>Nie znaleziono</em>
                            ) : (
                                <a href={`/information/${addr.id}`}>
                                    {[
                                        addr.postcode,
                                        addr.cityName,
                                        addr.streetName,
                                        addr.streetNumber,
                                    ]
                                        .filter(Boolean)
                                        .join(", ")}
                                </a>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
            </div>
        </div>
    );
};

export default InformationBulkUpdateItemsList;
